import { FormValidators } from 'utils/form/types';
import { isEmail, isNumber, isPhone, isRequired, isShortZipCode } from 'utils/form/validators';
import { EMAIL_SCHEDULE_FORM } from 'config/email/endpoints';
import EmailBaseFormStore from 'stores/common/EmailBaseFormStore';

export interface ScheduleForm {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  company: string;
  zipCode: string;
  numberOfEmployees: string;
  plan: string;
}

class ScheduleFormStore extends EmailBaseFormStore<ScheduleForm> {
  protected get endpoint(): string {
    return EMAIL_SCHEDULE_FORM;
  }

  protected getInitialForm(): ScheduleForm {
    return {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      company: '',
      zipCode: '',
      numberOfEmployees: '',
      plan: '',
    };
  }

  protected get validators(): FormValidators<ScheduleForm> {
    return {
      firstName: isRequired(),
      lastName: isRequired(),
      email: [isRequired(), isEmail()],
      phone: [isRequired(), isPhone()],
      company: isRequired(),
      zipCode: [isRequired(), isShortZipCode()],
      numberOfEmployees: [isRequired(), isNumber()],
      plan: [isRequired(), isNumber()],
    };
  }
}

export default ScheduleFormStore;
